import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-deployments-precondition.not-available-page.title',
		defaultMessage: "We can't show you Deployments",
		description:
			'Title of the page. This page is shown when users try to access Deployment/Deployment classic settings page when the user has no permission, or the Deployments feature is not enabled.',
	},
	description: {
		id: 'software-deployments-precondition.not-available-page.description',
		defaultMessage:
			"Either Deployments isn't enabled, or you need permission - contact your project admin",
		description:
			'Description of the page. This page is shown when users try to access Deployment/Deployment classic settings page when the user has no permission, or the Deployments feature is not enabled.',
	},
});
